import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { reducer, name, actions } from './slice';
import saga from './saga';
import makePackages from './selectors';

export default function usePackagesWithPaquer() {
  const dispatch = useDispatch();
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useSelector(makePackages(), shallowEqual);
  useEffect(() => {
    return () => {
      dispatch(actions.resetFilters());
    };
  }, [dispatch]);
  return null;
}
